import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import renderHTML from 'react-render-html';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts, relacionamentos } from '../../settings';
import { DelayLink, SliderText } from '../../components';

import './Iniciativas.scss';

class Iniciativas extends Component {
  constructor(props) {
		super(props);

		this.contentsFolder = './app/static/json/iniciativas/';

    this.contentText = React.createRef();
  }
		
	state = {
		contentId: null,
		notFound: false,
		loaded: false
	}

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentWillMount = () => {
		const { match: { params } } = this.props;
		this.setState({ contentId: params.id })
		this.getContent(params.id);
	}

  componentDidMount = () => {
    Actions.headerIntern();
		this.scrollTop();
  }

	getContent = contentId => {
		console.log('getContent', contentId);

		fetch(`${this.contentsFolder}${contentId}.json`)
		.then(response => {
			return response.json();
		})
		.then(myJson => {
			this.setState({
				loaded: true,
				content: myJson
			})
		})
		.catch(err => {
			console.warn('JSON not exists', err);
			this.setState({
				notFound: true
			})
		});
	}

  render = () => {
		const { notFound, content, loaded } = this.state;

    return (
      <div className="views" ref={this.contentText}>

				{
					notFound === true && 
					<Redirect
						to={{
							pathname: "/nao-encontrado",
							state: { from: this.props.location }
						}}
					/>
				}

				{
					loaded && content &&
					<Helmet>
						<title>{content.title} - Iniciativas - {texts.title}</title>
					</Helmet>
				}


				{
					loaded && content &&
					<div className="iniciativas-home page-gradient page-gradient--yellow bg-gray" ref="iniciativas-home">

						<section className="iniciativas-area page--yellow">
							<div className="container container--large">
								<div className="row">
									<div className="col-12">
										<Fade bottom>
											<div className={`card card--page-body card--${content.color}`}>
												<div className="card__content">
													<div className="card__content__header">
														<DelayLink to={content.back_link} className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick">
															Voltar
														</DelayLink>
														<h1 className="title title--gray">
															<span className="gri_text gri_text--fixed">
																{content.title}
																{content.gri && <span className="gri_label gray">GRI <b>{content.gri}</b></span>}
															</span>
														</h1>
													</div>
													<div className="card__content__body">
														{renderHTML(content.body.join(' '))}
													</div>
												</div>
												{
													content.image &&
													<div className="card__image">
														<img src={content.image} />
													</div>
												}
											</div>
										</Fade>
									</div>
								</div>
							</div>
						</section>

						{/* <section className="iniciativas-body">

							<div className="container container--large">
								<div className="row">
									
									<div className="col-12">
										<Fade bottom>
											<div className="card card--no-border card--para-o-mercado">
												<div className="card__content card__content--full">
													<div className="card__content__header card__content__header--no-border">
														<h3 className="title title--small yellow">O estudo também identifica as tendências internacionais para a indústria de gestão de recursos e os desafios que elas impõem ao mercado brasileiro:</h3>
													</div>

													<div className="card__content__body">

														<ul className="bullets bullets--yellow">
															<li><b>migração</b> das aplicações para ativos de maior valor agregado </li>
															<li><b>protagonismo</b> dos investidores na tomada de decisão </li>
															<li><b>crescimento</b> do uso de canais digitais </li>
															<li><b>uso</b> do suitability (análise do perfil do investidor) como diferencial competitivo </li>
															<li><b>inovação e tecnologia</b> para melhorar a eficiência da indústria</li>
														</ul>

														<p>
															A partir dessas tendências, o documento lista medidas necessárias para atender a cada um dos desafios apresentados. A Agenda ANBIMA para o Desenvolvimento da Indústria de Gestão de Investimentos inclui ajustes de caráter regulatório e autorregulatório, além de iniciativas institucionais de fomento ao setor. 
															<DelayLink to="/#" className="text_link text_link--yellow"> Confira o material completo.</DelayLink>
														</p>

														<img src={images.para_o_mercado.grafico_gestao} className="grafico_gestao" />
														
													</div>
												</div>
											</div>
										</Fade>
									</div>

								</div>
							</div>

						</section> */}

					</div>
				}

      </div>
    );
  }
}

export { Iniciativas };
